<p-drawer
    [(visible)]="visible"
    (visibleChange)="onVisibleChange($event)"
    (onShow)="onShow()"
    (onHide)="onHide()"
    position="right"
    [style]="{ width: '420px' }"
    [showCloseIcon]="false"
    appendTo="body"
    styleClass="chat-candidato-drawer"
>
    <ng-template #header>
        <div class="flex align-items-center justify-content-between w-full px-1">
            <div class="flex align-items-center gap-2">
                @if (desdePanelFab) {
                    <button
                        pButton
                        type="button"
                        icon="pi pi-arrow-left"
                        severity="secondary"
                        [text]="true"
                        (click)="volverAlListado()"
                        aria-label="Volver al listado de chats"
                        pTooltip="Volver al listado de chats"
                        tooltipPosition="bottom"
                    ></button>
                }
                <i-tabler name="brand-whatsapp" class="text-green-500"></i-tabler>
                <div class="flex flex-column">
                    <span class="font-semibold text-base">{{ nombreCompleto() }}</span>
                    <span class="text-xs text-color-secondary">{{ phone }}</span>
                </div>
            </div>
            <div class="flex align-items-center gap-1">
                <!-- Bot mini-toggle: estado ON/OFF compacto a la izquierda de Información -->
                <button
                    type="button"
                    class="bot-pill"
                    [class.bot-pill-on]="botEnabled()"
                    [class.bot-pill-off]="!botEnabled()"
                    [class.bot-pill-busy]="updatingAttribute() === 'estado_bot'"
                    [disabled]="updatingAttribute() !== null"
                    (click)="toggleBot()"
                    pTooltip="Activa o desactiva respuestas automáticas para este contacto."
                    tooltipPosition="bottom"
                    [attr.aria-label]="'Bot automático ' + (botEnabled() ? 'ON' : 'OFF')"
                >
                    @if (updatingAttribute() === 'estado_bot') {
                        <i class="pi pi-spin pi-spinner"></i>
                    } @else {
                        <span class="bot-dot"></span>
                    }
                    <span class="bot-label">Bot {{ botEnabled() ? 'ON' : 'OFF' }}</span>
                </button>
                <button
                    pButton
                    type="button"
                    [icon]="infoExpanded() ? 'pi pi-info-circle' : 'pi pi-info-circle'"
                    severity="secondary"
                    [text]="true"
                    (click)="toggleInfo()"
                    [class.text-primary]="infoExpanded()"
                    aria-label="Información"
                    pTooltip="Información del contacto"
                ></button>
                <button pButton type="button" icon="pi pi-times" severity="secondary" [text]="true" (click)="close()" aria-label="Cerrar"></button>
            </div>
        </div>
    </ng-template>

    <div class="chat-body">
        @if (loading()) {
            <div class="flex justify-content-center align-items-center h-full">
                <p-progressSpinner styleClass="w-3rem h-3rem"></p-progressSpinner>
            </div>
        } @else if (errorMessage()) {
            <div class="flex flex-column align-items-center justify-content-center h-full p-4 text-center">
                <i-tabler name="alert-circle" class="text-red-500 mb-2" style="width:32px;height:32px"></i-tabler>
                <span class="text-color-secondary">{{ errorMessage() }}</span>
            </div>
        } @else {
            @if (!mensajesLoading() && !puedeEscribir()) {
                <div class="restriction-banner">
                    <i-tabler name="alert-triangle" class="text-orange-600"></i-tabler>
                    <div class="banner-text">
                        <strong>Ventana de 24 h cerrada:</strong>
                        <span>el contacto debe escribirte primero. Puedes enviar una plantilla aprobada.</span>
                    </div>
                </div>
            }

            @if (infoExpanded()) {
                <div class="info-panel">
                    @if (contextLoading() && !context()) {
                        <div class="flex justify-content-center p-3">
                            <p-progressSpinner styleClass="w-2rem h-2rem"></p-progressSpinner>
                        </div>
                    } @else if (!context()) {
                        <div class="text-center text-color-secondary p-3">Sin información disponible.</div>
                    } @else {
                        <!-- Etiquetas -->
                        <div class="info-section">
                            <div class="info-section-header">
                                <i-tabler name="tag" class="icon-12"></i-tabler>
                                <span>Etiquetas</span>
                                @if (updatingAttribute() === 'labels') {
                                    <i class="pi pi-spin pi-spinner ml-1" style="font-size: 0.7rem"></i>
                                }
                            </div>
                            <p-multiselect
                                [options]="availableLabels()"
                                optionLabel="title"
                                optionValue="title"
                                [ngModel]="labels()"
                                (ngModelChange)="setLabels($event)"
                                display="chip"
                                placeholder="Agregar etiquetas..."
                                [showHeader]="true"
                                [filter]="true"
                                appendTo="body"
                                [disabled]="updatingAttribute() !== null"
                                styleClass="w-full"
                            ></p-multiselect>
                        </div>

                        <!-- Conversación -->
                        <div class="info-section">
                            <div class="info-section-header">
                                <i-tabler name="message-2" class="icon-12"></i-tabler>
                                <span>Conversación</span>
                            </div>
                            @if (conversationAttrs().length === 0) {
                                <span class="text-xs text-color-secondary">Sin atributos personalizados.</span>
                            } @else {
                                @for (attr of conversationAttrs(); track attr.key) {
                                    <div class="info-row">
                                        <span class="info-key">{{ attr.key }}</span>
                                        <span class="info-value">{{ formatAttrValue(attr.value) }}</span>
                                    </div>
                                }
                            }
                        </div>

                        <!-- Contacto -->
                        <div class="info-section">
                            <div class="info-section-header">
                                <i-tabler name="user" class="icon-12"></i-tabler>
                                <span>Contacto</span>
                            </div>
                            @if (contactInfo()) {
                                @if (contactInfo()?.name) {
                                    <div class="info-row">
                                        <span class="info-key">Nombre</span>
                                        <span class="info-value">{{ contactInfo()?.name }}</span>
                                    </div>
                                }
                                @if (contactInfo()?.email) {
                                    <div class="info-row">
                                        <span class="info-key">Email</span>
                                        <span class="info-value">{{ contactInfo()?.email }}</span>
                                    </div>
                                }
                                @if (contactInfo()?.identifier) {
                                    <div class="info-row">
                                        <span class="info-key">Identifier</span>
                                        <span class="info-value">{{ contactInfo()?.identifier }}</span>
                                    </div>
                                }
                                @for (attr of contactAttrs(); track attr.key) {
                                    <div class="info-row">
                                        <span class="info-key">{{ attr.key }}</span>
                                        <span class="info-value">{{ formatAttrValue(attr.value) }}</span>
                                    </div>
                                }
                            }
                        </div>
                    }
                </div>
            }

            @if (mensajesLoading()) {
                <div class="flex flex-column align-items-center justify-content-center flex-1 p-4 text-center gap-3">
                    <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="4"></p-progressSpinner>
                    <span class="text-color-secondary">Cargando mensajes…</span>
                </div>
            } @else if (mensajes().length === 0) {
                <div class="flex flex-column align-items-center justify-content-center flex-1 p-4 text-center">
                    <i-tabler name="message-circle" class="text-color-secondary mb-2" style="width:32px;height:32px"></i-tabler>
                    <span class="text-color-secondary">Inicia la conversación con {{ nombreCompleto() }}.</span>
                </div>
            } @else {
                <div #messagesContainer class="messages-container">
                    @for (m of mensajes(); track trackById($index, m); let i = $index) {
                        @if (isNewConversation(i, m)) {
                            <div class="conversation-separator">
                                <span class="conversation-separator-text">{{ conversationSeparatorLabel(m) }}</span>
                            </div>
                        }
                        @if (isActivity(m)) {
                            <div class="activity-row">
                                <span class="activity-text">{{ m.content }}</span>
                            </div>
                        } @else {
                            <div class="message-row" [class.outgoing]="isOutgoing(m)">
                                <div class="message-bubble" [class.bubble-outgoing]="isOutgoing(m)" [class.bubble-incoming]="!isOutgoing(m)">
                                    <div class="message-sender">{{ senderLabel(m) }}</div>
                                    @if (m.content) {
                                        <div class="message-content">{{ m.content }}</div>
                                    }
                                    @if (m.attachments?.length) {
                                        <div class="message-attachments">
                                            @for (att of m.attachments; track att.id) {
                                                @switch (att.file_type) {
                                                    @case ('image') {
                                                        <div class="attachment-media-wrap">
                                                            <button
                                                                type="button"
                                                                class="attachment-image"
                                                                (click)="downloadAttachment(att, $event)"
                                                                pTooltip="Click para descargar"
                                                                tooltipPosition="top"
                                                                aria-label="Descargar imagen"
                                                            >
                                                                <img [src]="proxyUrl(att.data_url)" alt="adjunto" loading="lazy" />
                                                            </button>
                                                            <button
                                                                type="button"
                                                                class="attachment-download-btn"
                                                                (click)="downloadAttachment(att, $event)"
                                                                pTooltip="Descargar"
                                                                tooltipPosition="left"
                                                                aria-label="Descargar"
                                                            >
                                                                <i class="pi pi-download"></i>
                                                            </button>
                                                        </div>
                                                    }
                                                    @case ('audio') {
                                                        <div class="attachment-media-row">
                                                            <audio controls preload="none" class="attachment-audio">
                                                                <source [src]="proxyUrl(att.data_url)" />
                                                            </audio>
                                                            <button
                                                                type="button"
                                                                class="attachment-download-btn inline"
                                                                (click)="downloadAttachment(att, $event)"
                                                                pTooltip="Descargar"
                                                                tooltipPosition="top"
                                                                aria-label="Descargar"
                                                            >
                                                                <i class="pi pi-download"></i>
                                                            </button>
                                                        </div>
                                                    }
                                                    @case ('video') {
                                                        <div class="attachment-media-wrap">
                                                            <video controls preload="metadata" class="attachment-video">
                                                                <source [src]="proxyUrl(att.data_url)" />
                                                            </video>
                                                            <button
                                                                type="button"
                                                                class="attachment-download-btn"
                                                                (click)="downloadAttachment(att, $event)"
                                                                pTooltip="Descargar"
                                                                tooltipPosition="left"
                                                                aria-label="Descargar"
                                                            >
                                                                <i class="pi pi-download"></i>
                                                            </button>
                                                        </div>
                                                    }
                                                    @default {
                                                        <button
                                                            type="button"
                                                            class="attachment-file"
                                                            (click)="downloadAttachment(att, $event)"
                                                            pTooltip="Click para descargar"
                                                            tooltipPosition="top"
                                                            aria-label="Descargar archivo"
                                                        >
                                                            <i class="pi pi-file"></i>
                                                            <div class="attachment-info">
                                                                <span class="attachment-name">{{ attachmentName(att) }}</span>
                                                                <span class="attachment-size">{{ formatFileSize(att.file_size) }}</span>
                                                            </div>
                                                            <i class="pi pi-download"></i>
                                                        </button>
                                                    }
                                                }
                                            }
                                        </div>
                                    }
                                    <div class="message-meta">
                                        <button
                                            type="button"
                                            class="copy-btn"
                                            (click)="copyMessage(m); $event.stopPropagation()"
                                            pTooltip="Copiar mensaje"
                                            tooltipPosition="top"
                                            aria-label="Copiar"
                                        >
                                            <i class="pi pi-copy"></i>
                                        </button>
                                        <span class="message-time">{{ m.created_at * 1000 | date: 'shortTime' }}</span>
                                        @if (estadoEntrega(m); as e) {
                                            <span class="estado-entrega-wrap" [pTooltip]="e.tooltip" tooltipPosition="top" [attr.aria-label]="e.tooltip">
                                                <i [class]="'estado-entrega ' + e.cls + ' ' + e.color"></i>
                                                @if (e.label) {
                                                    <span class="estado-entrega-label">{{ e.label }}</span>
                                                }
                                            </span>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    }
                </div>
            }
        }
    </div>

    <ng-template #footer>
        @if (pendingFiles().length) {
            <div class="pending-attachments">
                @for (pf of pendingFiles(); track pf.id) {
                    <div class="pending-attachment">
                        <i class="pi pi-paperclip"></i>
                        <span class="pa-name">{{ pf.file.name }}</span>
                        <span class="pa-size">{{ formatFileSize(pf.file.size) }}</span>
                        <button
                            type="button"
                            class="pa-remove"
                            (click)="removePendingFile(pf.id)"
                            aria-label="Quitar"
                            pTooltip="Quitar"
                        >
                            <i class="pi pi-times"></i>
                        </button>
                    </div>
                }
            </div>
        }
        <div class="chat-footer">
            <div class="chat-input-wrap">
                <textarea
                    class="chat-input"
                    [class.input-excedido]="excedeLimite"
                    [(ngModel)]="nuevoMensaje"
                    (keydown)="onEnterPress($event)"
                    [placeholder]="puedeEscribir() ? 'Escribe un mensaje...' : 'Solo plantillas disponibles'"
                    rows="2"
                    [disabled]="!conversationId() || enviando() || !puedeEscribir()"
                ></textarea>
                @if (nuevoMensaje.length > 0) {
                    <small class="char-counter" [class.char-counter--excedido]="excedeLimite">
                        {{ nuevoMensaje.length }} / {{ LIMITE_CARACTERES }}
                        @if (excedeLimite) { · supera el límite de WhatsApp, no se entregaría }
                    </small>
                }
            </div>
            <input
                #fileInput
                type="file"
                hidden
                accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
                (change)="onFileSelected($event)"
            />
            <div class="flex flex-column gap-1">
                <button
                    pButton
                    type="button"
                    icon="pi pi-paperclip"
                    severity="secondary"
                    pTooltip="Adjuntar archivo"
                    [disabled]="!conversationId() || enviando() || !puedeEscribir()"
                    (click)="fileInput.click()"
                ></button>
                <button
                    pButton
                    type="button"
                    icon="pi pi-file"
                    severity="info"
                    pTooltip="Enviar plantilla aprobada"
                    [disabled]="!conversationId() || enviando()"
                    (click)="openTemplatesDialog()"
                ></button>
                <button
                    pButton
                    type="button"
                    icon="pi pi-send"
                    severity="success"
                    [disabled]="!conversationId() || enviando() || !puedeEscribir() || excedeLimite || (!nuevoMensaje.trim() && pendingFiles().length === 0)"
                    [loading]="enviando()"
                    (click)="enviar()"
                ></button>
            </div>
        </div>
    </ng-template>
</p-drawer>

<p-dialog
    [visible]="templatesVisible()"
    (visibleChange)="onTemplatesVisibleChange($event)"
    [modal]="true"
    [style]="{ width: '520px', maxWidth: '95vw' }"
    [draggable]="false"
    [closeOnEscape]="true"
    [baseZIndex]="20000"
    appendTo="body"
    header="Enviar plantilla aprobada"
    (onHide)="closeTemplatesDialog()"
>
    @if (templatesLoading()) {
        <div class="flex justify-content-center p-4">
            <p-progressSpinner styleClass="w-3rem h-3rem"></p-progressSpinner>
        </div>
    } @else if (!selectedTemplate()) {
        @if (templates().length === 0) {
            <div class="text-center text-color-secondary p-4">No hay plantillas aprobadas en este inbox.</div>
        } @else {
            <div class="template-list">
                @for (tpl of templates(); track trackTemplate($index, tpl)) {
                    <div
                        class="template-item"
                        role="button"
                        tabindex="0"
                        (click)="selectTemplate(tpl, $event)"
                        (keydown.enter)="selectTemplate(tpl, $event)"
                    >
                        <div class="flex justify-content-between align-items-center mb-1">
                            <strong>{{ tpl.name }}</strong>
                            <span class="badge-cat">{{ tpl.category }}</span>
                        </div>
                        <div class="template-preview text-color-secondary">
                            {{ getBodyComponent(tpl)?.text }}
                        </div>
                    </div>
                }
            </div>
        }
    } @else {
        <div class="template-form">
            <div class="flex justify-content-between align-items-center mb-3">
                <strong>{{ selectedTemplate()?.name }}</strong>
                <button pButton type="button" icon="pi pi-arrow-left" severity="secondary" [text]="true" label="Atrás" (click)="backToTemplateList()"></button>
            </div>

            <div class="flex justify-content-end mb-2">
                <button
                    pButton
                    type="button"
                    icon="pi pi-sparkles"
                    label="Completar con IA"
                    class="p-button-sm"
                    severity="help"
                    [outlined]="true"
                    [disabled]="!puedeUsarIa()"
                    pTooltip="Pega un texto libre y la IA llena los parámetros de la plantilla"
                    tooltipPosition="top"
                    (click)="abrirDialogoIa()"
                ></button>
            </div>

            @if (templatePlaceholders().length === 0) {
                <p class="text-color-secondary">Esta plantilla no requiere parámetros.</p>
            } @else {
                <div class="flex flex-column gap-2 mb-3">
                    @for (p of templatePlaceholders(); track p) {
                        <label class="flex flex-column gap-1">
                            <span class="text-sm font-semibold">
                                {{ placeholderLabel(p) }}
                                <span class="text-xs text-color-secondary font-normal">{{ '{{' + p + '}}' }}</span>
                            </span>
                            <input
                                pInputText
                                type="text"
                                [class.param-input-invalido]="paramsInvalidos().has(p)"
                                [ngModel]="templateParams()[p]"
                                (ngModelChange)="onParamChange(p, $event)"
                            />
                            @if (paramsInvalidos().has(p)) {
                                <small class="param-error">
                                    <i class="pi pi-exclamation-triangle mr-1"></i>Sin saltos de línea ni tabs: WhatsApp rechaza parámetros multilínea (#132018).
                                </small>
                            }
                        </label>
                    }
                </div>
            }

            <div class="template-preview-box mb-3" [class.preview-box--excedido]="previewExcede()">
                <div class="flex justify-content-between align-items-baseline gap-2">
                    <small class="text-color-secondary">Previsualización:</small>
                    <small class="preview-counter" [class.preview-counter--excedido]="previewExcede()">
                        {{ templatePreview().length }} / {{ LIMITE_BODY_PLANTILLA }}
                    </small>
                </div>
                <div class="preview-text">{{ templatePreview() }}</div>
                @if (previewExcede()) {
                    <small class="preview-error">
                        <i class="pi pi-exclamation-circle mr-1"></i>WhatsApp rechaza plantillas con más de {{ LIMITE_BODY_PLANTILLA }} caracteres — acorta los valores de los parámetros.
                    </small>
                }
            </div>

            <div class="flex justify-content-end gap-2">
                <button pButton type="button" severity="secondary" label="Cancelar" (click)="closeTemplatesDialog()"></button>
                <button
                    pButton
                    type="button"
                    severity="success"
                    icon="pi pi-send"
                    label="Enviar"
                    [loading]="enviando()"
                    [disabled]="enviando() || paramsInvalidos().size > 0 || previewExcede()"
                    (click)="enviarPlantilla()"
                ></button>
            </div>
        </div>
    }
</p-dialog>

<p-dialog
    [visible]="iaDialogVisible()"
    (visibleChange)="iaDialogVisible.set($event)"
    [modal]="true"
    [style]="{ width: '480px', maxWidth: '95vw' }"
    [draggable]="false"
    [closable]="!iaCompletando()"
    [closeOnEscape]="!iaCompletando()"
    [baseZIndex]="21000"
    appendTo="body"
    header="✨ Completar parámetros con IA"
>
    <div class="flex flex-column gap-2">
        <p class="text-sm text-color-secondary m-0">
            Pega el mensaje que quieres enviar, tal como lo redactarías. La IA extraerá de ahí los valores de los
            parámetros de la plantilla. Después podrás revisar y editar cada valor.
        </p>
        <label class="flex flex-column gap-1">
            <span class="text-sm font-semibold">Pega aquí el mensaje que quieres enviar *</span>
            <textarea
                pTextarea
                rows="8"
                class="w-full"
                placeholder="Ej: Hola! Queremos invitarte al proceso de Auxiliar Logístico en Bogotá. El salario es de $1.623.500, el horario de lunes a sábado…"
                [ngModel]="iaTextoLibre()"
                (ngModelChange)="iaTextoLibre.set($event)"
                [disabled]="iaCompletando()"
            ></textarea>
        </label>
    </div>
    <ng-template #footer>
        <button
            pButton
            type="button"
            severity="secondary"
            label="Cancelar"
            [disabled]="iaCompletando()"
            (click)="iaDialogVisible.set(false)"
        ></button>
        <button
            pButton
            type="button"
            icon="pi pi-sparkles"
            label="Completar"
            [loading]="iaCompletando()"
            [disabled]="!iaTextoLibre().trim()"
            (click)="completarConIa()"
        ></button>
    </ng-template>
</p-dialog>
